import { ThemeProvider as ITwinThemeProvider } from '@itwin/itwinui-react';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getQueryVariable } from '../utils';
import { app } from "@microsoft/teams-js";

export type ThemeString = 'default' | 'dark' | 'contrast';

function initialTheme(): ThemeString {
  return getQueryVariable<ThemeString>('theme') ?? 'default';
}

const ThemeContext = createContext<ThemeString>(initialTheme());

export function ThemeProvider(props: any): JSX.Element {
  const [currentTheme, setCurrentTheme] = useState<ThemeString>(initialTheme());

  function setTheme(theme?: string): void {
    if (theme) {
      setCurrentTheme(theme as ThemeString);
    }
  }

  useEffect(() => {
    async function setInitialTheme(): Promise<void> {
      const context = await app.getContext();
      setTheme(context.theme);
    }

    microsoftTeams.registerOnThemeChangeHandler(setTheme);
    setInitialTheme().catch(error => console.error(error));
  }, []);

  return (
    <ITwinThemeProvider
      theme={currentTheme === 'default' ? 'light' : 'dark'}
      themeOptions={{
        highContrast: currentTheme === 'contrast',
      }}
      style={{ height: '100%', width: '100%' }}
    >
      <ThemeContext.Provider value={currentTheme}>
        {props?.children ?? null}
      </ThemeContext.Provider>
    </ITwinThemeProvider>
  );
}

export function useThemeContext(): ThemeString {
  return useContext(ThemeContext);
}
